import React from 'react';

export default function FilterLabel({ children }) {
  return <span className="font-weight-500 mr-2">{children}</span>;
}
